import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BoxWithHighLighting from 'components/with-hith-light-components/box-with-highlighting.component';
import { Content, Sample } from 'models/order';

type SampleContentProps = {
    sample: Sample;
    originalSample: Sample;
};

const SampleContent: FC<SampleContentProps> = ({ sample, originalSample }: SampleContentProps) => {
    const { t: translate } = useTranslation();

    const showSampleContent = () => {
        if (sample && sample.content) {
            return sample.content.some((content) => content.value);
        } else {
            return false;
        }
    };

    const formattedContent = (SampleContent: Content[]) => {
        return SampleContent?.filter((cont) => cont.value)
            ?.map((content) => translate(`orders:${content.name}`))
            ?.join(', ');
    };

    return (
        <Box>
            <Box display="flex">
                <Box mr={1}>
                    <Typography variant="subtitle2">{translate('orders:SAMPLE_TAKEN')}:</Typography>
                </Box>
                <BoxWithHighLighting
                    originalData={translate(`orders:${originalSample?.type || ''}`)}
                    data={translate(`orders:${sample.type || ''}`)}
                ></BoxWithHighLighting>
            </Box>

            {sample.type === 'PHYSICAL' && showSampleContent() ? (
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:CONTENT_IN_DELIVERY')}:</Typography>
                    </Box>
                    <BoxWithHighLighting
                        originalData={`${formattedContent(originalSample?.content as Content[])}`}
                        data={`${formattedContent(sample?.content as Content[])}`}
                    ></BoxWithHighLighting>
                </Box>
            ) : undefined}

            {sample.otherContent ? (
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:OTHER_CONTENT')}:</Typography>
                    </Box>
                    <BoxWithHighLighting
                        originalData={translate(`orders:${originalSample?.otherContent || ''}`)}
                        data={translate(`orders:${sample.otherContent || ''}`)}
                    ></BoxWithHighLighting>
                </Box>
            ) : undefined}
        </Box>
    );
};

export default SampleContent;
